// making sure my files load so we need to import each module here.
import './app/login/loginModule';
import './app/navigation/navigationModule';
import './app/authoring-tool/authToolModule';

import './app/commonFilter/commonFilterModule'
import './app/profileSetting/teacherViewModule'
import './app/profileSetting/hodViewModule'
import './app/profileSetting/hosViewModule'
import './app/profileSetting/parentViewModule'
import './app/profileSetting/profileViewModule'
import './app/profileSetting/supervisorViewModule'
import './app/parent-portal/childrenComponentModule';

import './app/privilege/privilegeModule';
import './app/authoring-tool/teachingPlan/teachingPlanModule'
import './app/authoring-tool/assignUsers/assignUserModule'
import './app/traditionalActivity/traditionalActivityModule'
import './app/report_cards/manage_reports/manageReportsModule';
import './app/report_cards/teacher/reportCardListModule';
import './app/report_cards/teacher/viewModule';
import './app/report_cards/approve_reports/approveReportsModule';
import './app/report_cards/published_reports/publishedReportModule';
import './app/report_cards/publish_reports/publishReportModule';
import './app/report_cards/student/publishedModule';
import './app/report_cards/class_teacher/clasteacherModule';
import './app/report_cards/teacher/generation/reportgenerationModule';
import './app/reporting-roles/reportingRolesModule';
import './app/createQuestion/createQuestionModule';

import './app/student_mapping/mappingModule';
import './app/edit_user/edituserModule'
import './app/people_lookup/peoplelookupModule'
import './app/authoring-tool/wizard/wizardModule'

import './app/educore_reports/class/module';
import './app/educore_reports/performance_analysis/module';
import './app/educore_reports/inidividual/module';
import './app/educore_reports/school/class_averageModule';
import './app/educore_reports/school/needing_attention';
import './app/educore_reports/school/performingsection';
import './app/educore_reports/school/sectionwiseAttention';
import './app/educore_reports/school/classaverageDiff';
import './app/educore_reports/cumulative/module';
import './app/educore_reports/standard/module';

import './app/initialSettings/curriculumConsole/curriculumConsoleModule';
import './app/initial_settings/academicconsoleModule';
import './app/initial_settings/userconsoleModule';
import './app/club_activity/clubModule';
import './app/club_activity/createclubModule';
import './app/utilities/curriculumSetup/curriculumSetupModule';
import './app/utilities/subjectSetup/subjectSetupModule';
import './app/holistics/sheets.scss'
import './app/utilities/sessionSetup/sessionSetupModule';
import './app/medical/medicalModule'


// WEBPACK FOOTER //
// ./src/app.components.js